import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdminTable from 'layouts/AdminTable';
import makeStyles from '@material-ui/styles/makeStyles';
import ExtensionIcon from '@material-ui/icons/Extension';
import DataGrid from 'components/DataGrid/DataGrid';
import Button from 'components/CustomButtons/Button.jsx';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import { isGranted } from 'helpers/helpers';
import { ROLE_CREATE_ADDON, ROLE_SHOW_MODULE_ADDONS } from 'helpers/roles';

import columnConfig from './columnConfig';

const useStyles = makeStyles({
  formStyles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});

const AddonsList = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const { pathname } = window.location;

  const classes = useStyles();

  return (
    <AdminTable
      title={t('views.addons.addons.list')}
      iconComponent={<ExtensionIcon />}
      settingsComponent={
        isGranted(ROLE_SHOW_MODULE_ADDONS) && (
          <Button
            color="secondary"
            onClick={() => history.push(`${pathname}/settings`)}
          >
            {t('views.addons.addons.settings')}
          </Button>
        )
      }
    >
      <div className={classes.formStyles}>
        {isGranted(ROLE_CREATE_ADDON) && (
          <FormControlButtons
            handleSubmit={() => history.push(`${pathname}/add`)}
            submitText={`${t('views.addons.addons.addAddon')} +`}
          />
        )}
      </div>
      <DataGrid
        actions={true}
        editPath={`${window.location.pathname}/edit`}
        remove={true}
        export={true}
        settings={true}
        paginationTop={true}
        paginationBottom={false}
        url="/addons"
        reportName="addon"
        columns={columnConfig({ t })}
        role="ADDON"
      />
    </AdminTable>
  );
};

export default AddonsList;
